// extracted by css-extract-rspack-plugin
export default {"root":"kC964u","section":"qLyNSZ","sectionTitle":"qjnXkC","row":"K6VUOT","rowLabel":"GzILtC","rowValue":"fi0NNm","hyperlink":"VLp9S5"};